/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-03-07 10:11:03
 */
export default{
    base:{
        search:'Search',
        add:'Add',
        edit:'Edit',
        save:'Save',
        delete:'Delete',
        cancel:'Cancel',
        download:'DownLoad',
        push:'Push',
        release:'Release',
        use:'Use',
        forbidden:'Forbidden',
        released:'Released',
        invalid:'Invalid',
        test:'Test',
        customCol:'Custom Columns',
        person:'Person Center',
        logout:'Logout',
        login:'Login',
        logoutMsg:'Confirm to exit the current login?',
        tip:'Tip',
        confirm:'Confirm',
        confirm2:'Confirm',
        cancel:'Cancel',
        cancelReplace:'Cancel Replace',
        reset:'Reset',
        yes:'Yes',
        no:'No',
        YES:'YES',
        NO:'NO',
        ok:'OK',
        uploadFirmware:'Upload Firmware',
        total:'Total',
        page:'Page',
        row:'Rows',
        upload:'Upload',
        uploadPicture:'Upload Picture',
        enter:'Please Enter',
        select:'Please Select',
        great:'Great',
        homeTitle:"works of art don't have to follow trends, they can lead trends themselves",
        selectFile:'Select File',
        selectDateRange:'Please select a date range',
        noData:'No Data',
        dataView:"DataView",
        downLoad:"DownLoad",
        close:"Close",
        refresh:'Refresh',
        currentDate:'Current Date',
        week:'Week',
        operate:'Operation',
        order_number:'No.',
        customColumns:'Custom Columns',
        delMsg:'Are you sure to delete?',
        uploadImg:'Upload Image',
        noEmpty:'cannot be empty!',
        needUploadImg:'Please upload pictures!',
        addSuccessMsg:'Successfully Added！',
        editSuccessMsg:'Successfully Edited！',
        delSuccessMsg:'Successfully Deleted！',
        saveSuccessMsg:'Successfully Save！',
        cancelSuccessMsg:'Canceled successfully！',
        sendSucceeded:'Send successfully !',
        downloadSucceeded:'Download successfully !',
        downloadFailed:'Download failed, please try again!',
        deleteConfirm:'Are you sure want to delete it?',
        clearLocalStorage:'Clear Cache',
        hasEmptyItem:'There are empty data items. Please fill them out before submitting!',
        more:'More',
        pickDate:"Please Select A Date",
        summary:'Summarize All',
        weekSummary:'Weekly Summary',
        normal:'Normal',
        selectConfirmMsg:'Are you sure about the selected item? Clicking OK will save the data',
        noEmpty:'can not be empty！',
        logoText:'Diagnostic Tool Management',
        zh:'CH',
        en:'EN',
        de:'DE',
        fr:'FR',
        exportData:'Export data',
        rows:'Rows',
        emailFormatError:'Please enter the correct email address format !',
        exporting:'Exporting...',
        exportSuccess:'Export successfully !',
        km:'KM',
        top: 'Top',
        GOBAO:'GOBAO',
        HEPHA:'HEPHA',
        pleaseSelect:'Please Select',
        checkAll:'Check All',
        rollBack:'Version Rollback',
        revokeDelete:'Revoke Delete',
        reset:'Reset',
        error:'Error',
        url:'URL',
        method:'Method',
    },
    menu:{
        Home:'Home',
        DataQuery:'Data Query',
        CyclingData:'Riding Data',
        BikeInfo:'Bike Information',
        AdvancedFunction:'Adv. Feature',
        AccessMTG:'Access Management',
        AccountMTG:'Account Management',
        SystemMTG:'System Settings',
        Role:'Role Management',
        Menu:'Menu Management',

        subHome:'Welcome to hepha backend.',
        subCyclingData:'User riding data statistics and management.',
        subBikeInfo:'Configuration information management.',
        subAccessMTG:'Digitally empowered, everything under control.',
        subAccountMTG:'Administrators can manage permissions for backend accounts.',
        subRoleMTG:'Administrators can manage roles for backend accounts.',
        subMenuMTG:'Administrators can manage menus for backend accounts.',
    },
    login:{
        loginSucceeded:'Login succeeded !',
        resetSucceeded:'Reset succeeded! Please log in again.',
        desc:'Before accessing the backend website.',
        subDesc:'Please log in to your account.',
        email_address:'Email address',
        password:'Password',
        login:'Log in now',
        rememberPassword:'Remember me',
        send:'Send',
        reset:'Reset',
        forgotPassword:'Forgot the password?',
        createAccount:'Create an account',
        createSubDesc:'Please fill in your contact information.',
        resetPassword:'Reset password',
        resetSubDesc:'Please fill in the email address you used at registration toreset your password.',
        adminEmail:"Administrator's email",
        firstName:'First name',
        lastName:'Last name',
        companyName:'Company name',
        emailAddress:'Email address',
        telephone:'Telephone',
        password:'Password',
        comfirmPassword:'Comfirm password',
        verificationCode:'Verification code',
        newPassword:'New password',
        reEnterPassword:'Re-enter the password',
        createAccountBtn:'Sent request to create an account',
        requestOnce:'You can only request a verification code once per minute.',
        hephaAdminEmail:"HEPHA administrator's email:",
        useAccountLogin:'Log in using your access credentials',
        note:'Note:',
        msg1:'We will send a confirmation email to you first. Once you confirm the email, your registration information will be recorded in the backend.',
        msg2:'After the administrator activates it in the backend, your account will be successfully registered.',
        msg3:'You are required to confirm the email first, and then the administrator needs to activate your account in the backend.',
        // passwordFormat:'Support only 6 to 10 numbers and letters, do not support special characters.',
        passwordFormat:'Le mot de passe doit comporter au moins 8 caractères et inclure des lettres majuscules et minuscules, ainsi qu\'au moins un chiffre.',
        confirmPasswordFormat:'Please confirm the password again',

        selectTenant:'Select Tenant',
        selectTenantTip:'Please select tenant account authorization login',
        normal:'Normal',
        noAvive:'No Avive',
        logout:'Logout',
        logoutTip:'Are you sure log out?',

        resend:'Resend email',
        noActiveTip:'Your account is not activated, please check your email for activation instructions or resend the email to activate.'
    },
    home:{
        morning:'Good Morning!',
        forenoon:'Good Forenoon!',
        noon:'Good Noon!',
        afternoon:'Good Afternoon!',
        evening:'Good Evening!',
        welcome:'Welcome to HEPHA Ecological Platform!',

        totalSale:"Total E-bike sales",
        lastWeekActivationNum:"Last week's active users.",
        lastWeekSegmentCount:"Last week's activated users.",
        currentDate:'Local time: ',
        cityDistribution:'Map Of Activated Users',
        table:'Table',
        map:'Map',
        country:'Country',
        state:'State',
        city:'City',
        num:'Number',
        torqueChartTitle:'Statistics of maximum torque.',
        maxTorqueData:'Maximum torque data',
    },
    cycling:{
        queryUserRideData:'Query user riding data',
        statisticsAllUsers:'Statistics of all users',
        mileageRank:'Mileage ranking',
        downloadUserCyclingListData:'Export user cycling data',
        totalCyclingStatistics:'Total Ride Statistics',
        frameNumber:'Frame number',
        assemblyCode:'Drive unit sn',
        totalDistance:'Total ride distance(KM)',
        totalTime:'Total ride time(H)',
        totalRides:'Total no. of rides',
        trampling_laps:'Total trampling laps',
        maxDist:'Max distance per single ride',
        maxCadence:'Max cadence per single ride',
        maxSpeed:'Max speed single ride',
        totalMileageRangeStatistics:'Total mileage range statistics',
        totalNumberOfRidesStatistics:'Total number of rides statistics',
        rideDataUser:'Riding data of user',
        eco:'ECO',
        tour:'TOUR',
        turbo:'TURBO',
        motorCode:'Motor code',
        chartTip1:'Statistical data on motor power and total riding time.',
        chartTip2:'Statistical data on total power and total riding time',
        chartTip3:'Statistical data on riding mode and total riding time',
        chartTip4:'Statistical data on cadence and total riding time.',
        chartTip5:'Statistical data on human toque and total riding time.',
        chartTip6:'Statistical data on motor toque and total riding time.',
        chartTip7:'Please enter the frame number or motor code of the data to be queried.',

        downloadRideData:'Export riding data',

        downloadChart1:'Export motor power statistics data',
        downloadChart2:'Export total human power statistics data',
        downloadChart3:'Export total share of riding mode use',
        downloadChart4:'Export cadence statistics data',
        downloadChart5:'Export human torque statistics data',
        downloadChart6:'Export motor output torque statistics data',

        mileageZoneCountData:'Total mileage range statistics data',
        rideCountData:'Total number of rides statistics data',
        downloadAllUserMileageZoneCount:'Export total mileage range statistics data',
        downloadRideCount:'Export total number of rides statistics data',

        motorPowerStatistics:'Motor power statistics',
        totalHumanPowerStatistics:'Total human power statistics',
        totalShareOfRidingModeUse:'Total share of riding mode use',
        cadenceStatistics:'Cadence statistics',
        humanTramplingTorqueStatistics:'Human torque statistics',
        motorOutputTorqueStatistics:'Motor output torque statistics',

        // humanTorqueStatistics:'Human Torque Statistics',
        // treadmillStatistics:'Treadmill statistics',
       

        rank:'Rankink List',
        top10:'Top 10',
        top20:'Top 20',
        top50:'Top 50',
        top100:'Top 100',
        chartTitle:'EBike Total Mileage(KM)',
        chartTitle2:'User Total Mileage(KM)',
        downloadMile:'Export EBike/User Total Mileage',
        totalMile:'EBike and User Total Mileage Data',
    },
    bikeInfo:{
        queryBikesInfo:'Query bikes info',
        generalInfo:'General information',
        brand:'Brand',
        bikeColor:'Bike color',
        driveUnitModel:'Drive unit model',
        modelYear:'Model year',
        bikeModel:'Bike model',
        placeOfProduction:'Place of production',
        bikeOfflineTime:'Bike offline time',
        driveUnitSerialNumber:'Drive unit serial number',
        batterySerialNumber:'Battery serial number',
        displaySerialNumber:'Display serial number',
        batteryKeySerialNumber:'Battery key serial number',
        driveUnitHardwareVersion:'Drive unit hardware version',
        batteryHardwareVersion:'Battery hardware version',
        displayHardwareVersion:'Display hardware version',
        driveUnitSoftwareVersion:'Drive unit software version',
        batterySoftwareVersion:'Battery software version',
        displaySoftwareVersion:'Display software version',

        systemInformation:'System information',
        torque:'Torque',
        assistanceLevel:'Assistance level',
        ridingDynamics:'Riding dynamics',
        restistanceCompensation:'Restistance compensation',
        walkModeSpeed:'Walk mode speed',
        wheelCircumference:'Wheel circumference',
        maxSupportedSpeed:'Max. supported speed',
        maxTorque:'Max. torque',

        item:'ITEM',
        eco:'ECO',
        tour:'TOUR',
        turbo:'TURBO',

        bikeData:'Query bike data',
        bikeInfoData:'Bike information data',

        ebikeInfo:'E-bike information',
        motorInstallationAngle:'Motor installation angle',
        modelSpeedSensor:'Model of speed sensor',
        amountFrontChainring:'The amount of the front chainring',
        maxTeethChainring:'Max. teeth on the front chainring',
        minTeethChainring:'Min. teeth on the front chainring',
        
        speedsCassette:'The number of speeds on the cassette',
        maxTeethCassette:'Max. teeth on the cassette',
        minTeethCassette:'Min. teeth on the cassette',
        maxGearRatio:'Max. gear ratio',
        minGearRatio:'Min. gear ratio',
        numberTeethSprocket:'The number of teeth on the sprocket',
        externalGear:'External gear',
        internalGear:'Internal gear',

        exportTip:'Frame number or assembly code can not be empty !'
    },
    access:{
        searchUser:'Search User',
        frameNumber:'Frame number',
        motorSN:'Motor SN',
        userEmail:'User email',
        phoneKey:'Phone key',
        maximumTorque:'Maximun torque',
        motorChangeStatus:'Motor change status',
        upgradeTorqueStatus:'Upgrade torque status',
        editAuth:'Edit/Authorisation',
        changeRecord:'Records',
        torqueUpgrade:'Torque upgrade',
        unbindUser:'Unbind user',
        paramConfig:'Parameters configuration',
        softwareUpdate:'Software update',
        motorReplace:'Motor replacement',
        appBind:'App binding',
        waiting:'Waiting',
        toBeReplace:'To be replaced',
        cancel:'Cancel',
        partNumber:'Part number',
        partName:'Part name',
        projectNumber:'Project number',
        companyId:'Company ID',
        assemblyCode:'Drive unit sn',
        softwareVersion:'Software version',
        hardwareVersion:'Hardware version',
        latestSoftwareVersion:'Latest software version',
        deletePart:'Delete part',
        editTorque:'Edit Torque',
        torqueEditSuccessMsg:'Torque editing successful, waiting for upgrade！',
        unbindBikeUserConfirmMsg:'Are you sure to unbind the ebike user?',
        deletePartConfirmMsg:'Are you sure to delete part?',
        
        vehicle_name:'E-Bike name',
        color:'Color',
        vehicle_status:'Vehicle name',
        triple_id:'Triple ID',
        vehicle_name:'E-Bike name',
        vehicle_name:'E-Bike name',
        vehicle_name:'E-Bike name',

        addConfig:'Add Configs',
        historyVersion:'View Historical Versions',
        versionDate:'Version Date',
        creatorId:'Creator ID',
        versionTitle:'Config Info Historical Versions',
        createTimestamp:'Create Timestamp',
        creatorId:'Creator ID',
        configInfoConfirm:'Config Info Confirm',
        replaceConfig:'Update Config',

        init_torque:'Init torque',
        target_torque:'Target torque',
        status:'Status',
        create_time:'Create time',
        cancel_time:'Cancel time',
        finish_time:'Finish time',

        bind_category:'Bind Category',
        bind_time:'Bind time',
        bind_mode_category:'Bind Mode Category',

        confirmMsg:'Are you sure you want to apply for motor replacement?',
        confirmMsg2:'Are you sure to apply for updating the configuration?',
    
        bindRecord:'EBike Bind',
        torqueUpgradeRecord:'Torque Upgrade',
        motorApplyRecord:'Motor Replace',
        deletePartConfirmMsg:'Are you sure to delete part?',
        cancelTorqueUpgradeMsg:'Are you sure to cancel the torque upgrade?',
        cancelMotorApplyMsg:'Are you sure to cancel the motor replacement application?',

        activated:'Activated',
        unbound:'Unbound',
        maintenance:'Maintenance',
        main_vehicle:'Main EBike',
        free_vericle:'Free Vericle',
        delivery:'Delivery',
    
        marketVehicle:'Market EBike',
        testVehicle:'Test EBike',
        plc:'PLC',
        can:'CAN',
        unboundSuccessful:'Unbind successfully!',
        applyed:'Applied for',
        saveConfigTip:'Please add configs!',

        config_name:'Name',
        config_name_en:'Name(EN)',
        config_name_de:'Name(DE)',
        config_device:'Device',
        config_item:'Config Item',
        config_encrypt:'Encrypt',
        config_max:'Max Value',
        config_min:'Min Value',
        config_size:'Size',
        config_unit:'Unit',
        config_value:'Value',
        config_coefficient:'Coefficient',
        valueMaxTip:'Cannot exceed the maximum value!',
        valueMinTip:'Cannot be less than the minimum value!',
        confirmRollBackTip:'Are you sure to roll back to this version?',
        noVersionData:'No Version Data',
        rollBackSuccess:'Version rollback successful!',
        binding:'Binding',
        unbinding:'Unbinding',
        assembly:'Assembly',
        frame:'Frame',
        waitUpgrade:'Waiting for upgrade',
        finish:'Finish',
        cancel:'Cancel',
    
        applyReplaceMotor:'Replace Motor',
        motorApplyRecord:'Motor Replace',

        deleteSuccessful:'Delete Successfully!',
        configChangeItem:'Config Change Items',
        motorReplacement:'Motor Replacement',

        config_old_value:'Old Value',
        config_new_value:'New Value',
        category:'Category', 
        configInfo:'Config Info',
        confirmConfigInfoMsg:'Please confirm the config information!',
    
        cycling_mileage:'Riding Mileage',
        init_triple_id:'Init Triple ID',
        target_triple_id:'Target Triple ID',
        apply_status:'Replace Status',
        apply_create_time:'Create Date',
        replace_category:'Category',
    },
    account:{
        createAddAccount:'Create account',
        adminAccountEmail:'Administrator account email',

        backendAccountEmail:'Backend account email',
        registrationDate:'Registration date',
        registrationAuthEmail:'Registration authorisation email',
        spareMotorReplace:'Spare motor replacement',
        parameterConfig:'Parameter configuration',
        torqueupGrade:'Torque upgrade',
        unbindUser:'Unbind user',
        usageState:'Usage state',

        userAuthorizedFunc:'User Authorized Functions',

        category:"Category",
        status:'Status',
        normal:'Normal',
        unactivated:'Unactivated',
        disabled:'Disabled',
        tenant:'Tenant',

        contractManufacturer:'Contract manufacturer',
        ordinaryBackEndAccount:'Ordinary back-end account',

        auth:'Authorisation',
        authDetail:'Detail',
        authorize:'Authorize',
        updateTorque:'Update torque',
        unbindAccount:'Unbind user',
        diasbleAccount:'Disable account',
        activateAccount:'Unban account',
        diasbleActivate:'Disable/Unban',
        endOffLine:'End off line',
        createConfig:'Create config',

        back:'Back',
        emailAddr:'Email address',
        firstName:'First name',
        lastName:'Last name',
        companyName:'Company name',
        telephone:'Telephone',
        accountType:'Account type',
        password:'Password',
        confirmPsw:'Confirm password',
        create:'Create',
        createTip1:'lf this email has not been registered, we will send a conformation email to the user. Once confirmed by the user, the email will be successfully added to the backend.',
        createTip2:'lf the email has clearly been registered, you can add it directly to the backend.',
    
        notice:'Notice',
        unbindTip:'Are you confirmed the unbound user ?',
        disableTip:'Are you confirmed the disable account ?',
        activeTip:'Are you confirmed the active account ?',
    
        pswTip:'The passwords are inconsistent !',
    },
    role:{
        createRole:'Create Role',
        edit:'Edit',
        delete:'Delete',
        editRole:'Edit Role',
        roleName:'Role Name',
        roleDesc:'Role Description',
        tenant:'Tenant',
        gobao:'Gobao',
        hepha:'Hepha',
        deleteTip:'Are you confirmed the delete role ?',
        bindMenu:'Bind Menu',
        bindMenuSuccess:'Bind menu successfully!',
        tenant:'Tenant',
    },
    menuMgt:{
        createMenu:'Create Menu',
        editMenu:'Edit Menu',
        menuName:'Menu Name',
        menuPath:'Menu Path',
        menuIndex:'Menu Index',
        menuParent:'Menu Parent',
        menuLevel:'Menu Level',
        menuType:'Menu Type',
        menuUrl:'Menu URL',
        menuMethod:'Menu Method',
        menuIcon:'Menu Icon',
        menuId:'Menu ID',

        page:'Page',
        button:'Button',
        businessFun:'Business Function',
        interface:'Interface',

        menuTop:'Top-level menu',
        menuLevel1:'First-level',
        menuLevel2:'Second-level',
        menuLevel3:'Third-level',
    },
    part:{
        AddPart:'Add Part',
        editPart:'Edit Part',
        model_category:'Model Category',
        model_key:'Assembly Position',
        model_value:'Model Name',
        avatar_url:'Part Picture',
        uploadTitle:'Upload Picture',
        motor:'Drive Unit',
        display:'Display',
        battery:'Battery',

        addFaultCode:'Add Fault Code',
        editFaultCode:'Edit Fault Code',

        fault_code:'Fault Code',
        fault_path:'URL',
        fault_status:'Fault Status',
        fault_limit:'Fault Limit',
        fault_measure:'Fault Measure',
        fault_status_de:'Fault Status (DE)',
        fault_limit_de:'Fault Limit (DE)',
        fault_measure_de:'Fault Measure (DE)',
        fault_status_fr:'Fault Status (FR)',
        fault_limit_fr:'Fault Limit (FR)',
        fault_measure_fr:'Fault Measure (FR)',
    },
    config:{
        label_name:'Label Name(En)',
        label_name_de:'Label Name(De)',
        label_name_fr:'Label Name(Fr)',
        addLabel:'Add Label',
        editLabel:'Edit Label',
    },
    sys:{
        // home:{
        //     home:'Home',
        // },
        // dataQuery:{
        //     cyclingData:'Riding Data',
        //     bikeInfo:'Bike Information',
        // }
    }
}